export default __webpack_public_path__ + "static/media/Identities_TuscanRise@2x.eeac2caf.jpg";